export function digitsAndDecimal(value: string) {
  const cleaned = value.replace(/[^\d.]/g, "");
  const dotIndex = cleaned.indexOf(".");
  if (dotIndex === -1) return cleaned;
  return (
    cleaned.slice(0, dotIndex + 1) +
    cleaned.slice(dotIndex + 1).replace(/\./g, "")
  );
}

export function signedDecimal(value: string) {
  const negative = value.startsWith("-");
  const rest = digitsAndDecimal(negative ? value.slice(1) : value);
  if (negative && rest === "") return "-";
  return negative ? `-${rest}` : rest;
}
